import { render } from "./CreateAgent.vue?vue&type=template&id=2cf6e162&scoped=true"
import script from "./CreateAgent.vue?vue&type=script&lang=js"
export * from "./CreateAgent.vue?vue&type=script&lang=js"

import "./CreateAgent.vue?vue&type=style&index=0&id=2cf6e162&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\ms\\ms-by-bimms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cf6e162"]])

export default __exports__